import React, { useState, useEffect } from 'react';

const PreMarketAuto = () => {
  const [status, setStatus] = useState(null);
  const [candidates, setCandidates] = useState([]);
  const [pendingOrders, setPendingOrders] = useState([]);
  const [openPositions, setOpenPositions] = useState([]);
  const [closedPositions, setClosedPositions] = useState([]);
  const [lifetime, setLifetime] = useState(null);
  const [loading, setLoading] = useState(true);
  const [running, setRunning] = useState(false);

  const fetchAll = async () => {
    try {
      const [s, cd, pd, op, cp, lt] = await Promise.all([
        fetch('/premarket/status').then(r => r.json()),
        fetch('/premarket/candidates').then(r => r.json()),
        fetch('/premarket/positions?status=PENDING_FILL').then(r => r.json()),
        fetch('/premarket/positions?status=OPEN').then(r => r.json()),
        fetch('/premarket/positions?status=CLOSED&limit=30').then(r => r.json()),
        fetch('/premarket/lifetime').then(r => r.json())
      ]);
      setStatus(s);
      setCandidates(cd.candidates || []);
      setPendingOrders(pd.positions || []);
      setOpenPositions(op.positions || []);
      setClosedPositions(cp.positions || []);
      setLifetime(lt);
    } catch (err) {
      console.error('Pre-market fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  const runNow = async () => {
    if (!window.confirm('Run pre-market hunt + place orders now? (paper only)')) return;
    setRunning(true);
    try {
      const r = await fetch('/premarket/run-now', {method: 'POST'}).then(r => r.json());
      alert('Run: ' + JSON.stringify(r));
      fetchAll();
    } catch (err) {
      alert('Error: ' + err.message);
    } finally {
      setRunning(false);
    }
  };

  useEffect(() => {
    fetchAll();
    const iv = setInterval(fetchAll, 30000);
    return () => clearInterval(iv);
  }, []);

  const fmtRs = (v) => v == null ? '—' :
    (v >= 0 ? '+' : '') + '₹' + Math.round(v).toLocaleString('en-IN');

  const fmtPct = (v) => v == null ? '—' : (v >= 0 ? '+' : '') + v.toFixed(2) + '%';

  const getPnLColor = (v) => v == null ? '#666' : v > 0 ? '#0a7' : v < 0 ? '#c33' : '#666';

  const convictionStyle = (c) => ({
    background: c === 'HIGH' ? '#f6ffed' : c === 'MODERATE' ? '#fffbe6' : '#fff1f0',
    color: c === 'HIGH' ? '#389e0d' : c === 'MODERATE' ? '#ad8b00' : '#cf1322',
    padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 600
  });

  if (loading) return <div style={{padding: 20}}>Loading Pre-market Auto...</div>;

  const selectedCandidates = candidates.filter(c => c.selected);

  return (
    <div style={{padding: 20, fontFamily: 'system-ui'}}>
      <details style={{background: '#fff7e6', padding: '8px 12px', borderRadius: 8, marginBottom: 16, border: '1px solid #ffd591'}}>
        <summary style={{fontWeight: 600, color: '#ad4e00', cursor: 'pointer'}}>Pre-market Auto v2.0 (rules)</summary>
        <div style={{fontSize: 13, color: '#555', marginTop: 4}}>
          Runs 9:02 AM · IEP-based limits · Max 5 fills/day · HIGH conviction = aggressive limit (guaranteed IEP fill) · MODERATE = exact IEP · Unfilled killed at 9:45 · Time-gate exits (10:00 &lt;+1%, 12:00 &lt;+2% if green) · Force EOD at 3:20 PM
        </div>
      </details>

      {/* Lifetime */}
      {lifetime && (
        <div style={{background: '#fff', padding: 16, border: '1px solid #ddd', borderRadius: 8, marginBottom: 16}}>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12}}>
            <div style={{fontWeight: 600}}>PRE-MARKET AUTO — LIFETIME (Paper Mode)</div>
            <button onClick={runNow} disabled={running}
              style={{padding: '6px 16px', background: '#fa8c16', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12}}>
              {running ? 'Running...' : 'Run Now (manual test)'}
            </button>
          </div>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16}}>
            <div>
              <div style={{fontSize: 12, color: '#888'}}>REALIZED</div>
              <div style={{fontSize: 20, fontWeight: 600, color: getPnLColor(lifetime.realized_pnl_net)}}>
                {fmtRs(lifetime.realized_pnl_net)}
              </div>
              <div style={{fontSize: 12, color: '#666'}}>{lifetime.closed_count} closed · WR {lifetime.win_rate_pct}%</div>
            </div>
            <div>
              <div style={{fontSize: 12, color: '#888'}}>PENDING ORDERS</div>
              <div style={{fontSize: 20, fontWeight: 600, color: '#fa8c16'}}>{status?.pending_orders || 0}</div>
              <div style={{fontSize: 12, color: '#666'}}>waiting for 9:15 fill</div>
            </div>
            <div>
              <div style={{fontSize: 12, color: '#888'}}>OPEN POSITIONS</div>
              <div style={{fontSize: 20, fontWeight: 600}}>{lifetime.open_count}</div>
            </div>
            <div>
              <div style={{fontSize: 12, color: '#888'}}>TODAY REALIZED</div>
              <div style={{fontSize: 20, fontWeight: 600, color: getPnLColor(status?.today_pnl_net)}}>
                {fmtRs(status?.today_pnl_net)}
              </div>
              <div style={{fontSize: 12, color: '#666'}}>{status?.closed_today} closed today</div>
            </div>
          </div>
        </div>
      )}

      {/* Pending Orders */}
      {pendingOrders.length > 0 && (
        <div style={{background: '#fff', padding: 16, border: '1px solid #ddd', borderRadius: 8, marginBottom: 16}}>
          <div style={{fontWeight: 600, marginBottom: 12, color: '#fa8c16'}}>
            Pending Orders ({pendingOrders.length}) — waiting for 9:15 fill
          </div>
          <table style={{width: '100%', fontSize: 13, borderCollapse: 'collapse'}}>
            <thead style={{background: '#fafafa'}}>
              <tr>
                <th style={{padding: 8, textAlign: 'left'}}>Ticker</th>
                <th style={{padding: 8, textAlign: 'left'}}>Conviction</th>
                <th style={{padding: 8, textAlign: 'left'}}>Order Type</th>
                <th style={{padding: 8, textAlign: 'right'}}>IEP</th>
                <th style={{padding: 8, textAlign: 'right'}}>Limit Price</th>
                <th style={{padding: 8, textAlign: 'right'}}>Qty</th>
              </tr>
            </thead>
            <tbody>
              {pendingOrders.map(p => (
                <tr key={p.id} style={{borderTop: '1px solid #eee'}}>
                  <td style={{padding: 8, fontWeight: 600}}>{p.ticker}</td>
                  <td style={{padding: 8}}><span style={convictionStyle(p.conviction)}>{p.conviction}</span></td>
                  <td style={{padding: 8, fontSize: 11}}>{p.order_type}</td>
                  <td style={{padding: 8, textAlign: 'right'}}>₹{p.iep?.toFixed(2)}</td>
                  <td style={{padding: 8, textAlign: 'right'}}>₹{p.placed_limit_price?.toFixed(2)}</td>
                  <td style={{padding: 8, textAlign: 'right'}}>{p.qty}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Open Positions */}
      <div style={{background: '#fff', padding: 16, border: '1px solid #ddd', borderRadius: 8, marginBottom: 16}}>
        <div style={{fontWeight: 600, marginBottom: 12}}>Open Positions ({openPositions.length})</div>
        {openPositions.length === 0 ? (
          <div style={{color: '#888', fontSize: 13}}>No open positions</div>
        ) : (
          <div style={{overflowX: 'auto'}}>
            <table style={{width: '100%', fontSize: 13, borderCollapse: 'collapse'}}>
              <thead style={{background: '#fafafa'}}>
                <tr>
                  <th style={{padding: 8, textAlign: 'left'}}>Ticker</th>
                  <th style={{padding: 8, textAlign: 'right'}}>Entry</th>
                  <th style={{padding: 8, textAlign: 'right'}}>Qty</th>
                  <th style={{padding: 8, textAlign: 'right'}}>SL</th>
                  <th style={{padding: 8, textAlign: 'left'}}>Stage</th>
                  <th style={{padding: 8, textAlign: 'left'}}>Conviction</th>
                  <th style={{padding: 8, textAlign: 'right'}}>MFE%</th>
                </tr>
              </thead>
              <tbody>
                {openPositions.map(p => (
                  <tr key={p.id} style={{borderTop: '1px solid #eee'}}>
                    <td style={{padding: 8, fontWeight: 600}}>{p.ticker}</td>
                    <td style={{padding: 8, textAlign: 'right'}}>₹{p.entry_price?.toFixed(2)}</td>
                    <td style={{padding: 8, textAlign: 'right'}}>{p.qty}</td>
                    <td style={{padding: 8, textAlign: 'right'}}>₹{p.stop_loss?.toFixed(2)}</td>
                    <td style={{padding: 8, fontSize: 12}}>{p.current_stage}</td>
                    <td style={{padding: 8}}><span style={convictionStyle(p.conviction)}>{p.conviction}</span></td>
                    <td style={{padding: 8, textAlign: 'right'}}>{fmtPct(p.mfe_pct)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Closed Positions */}
      <div style={{background: '#fff', padding: 16, border: '1px solid #ddd', borderRadius: 8}}>
        <div style={{fontWeight: 600, marginBottom: 12}}>Closed (last 30)</div>
        {closedPositions.length === 0 ? (
          <div style={{color: '#888', fontSize: 13}}>No closed positions yet</div>
        ) : (
          <div style={{overflowX: 'auto'}}>
            <table style={{width: '100%', fontSize: 13, borderCollapse: 'collapse'}}>
              <thead style={{background: '#fafafa'}}>
                <tr>
                  <th style={{padding: 8, textAlign: 'left'}}>Ticker</th>
                  <th style={{padding: 8, textAlign: 'right'}}>Entry</th>
                  <th style={{padding: 8, textAlign: 'right'}}>Exit</th>
                  <th style={{padding: 8, textAlign: 'left'}}>Reason</th>
                  <th style={{padding: 8, textAlign: 'left'}}>Conviction</th>
                  <th style={{padding: 8, textAlign: 'right'}}>Net P&L</th>
                  <th style={{padding: 8, textAlign: 'right'}}>MFE%</th>
                </tr>
              </thead>
              <tbody>
                {closedPositions.map(p => (
                  <tr key={p.id} style={{borderTop: '1px solid #eee'}}>
                    <td style={{padding: 8, fontWeight: 600}}>{p.ticker}</td>
                    <td style={{padding: 8, textAlign: 'right'}}>₹{p.entry_price?.toFixed(2)}</td>
                    <td style={{padding: 8, textAlign: 'right'}}>₹{p.exit_price?.toFixed(2)}</td>
                    <td style={{padding: 8, fontSize: 11}}>{p.exit_reason}</td>
                    <td style={{padding: 8}}><span style={convictionStyle(p.conviction)}>{p.conviction}</span></td>
                    <td style={{padding: 8, textAlign: 'right', color: getPnLColor(p.net_pnl), fontWeight: 600}}>
                      {fmtRs(p.net_pnl)}
                    </td>
                    <td style={{padding: 8, textAlign: 'right'}}>{fmtPct(p.mfe_pct)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default PreMarketAuto;
